"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _InfoLabel = _interopRequireDefault(require("../../../../../components/InfoLabel"));
var _helpers = require("../../../../../components/WithPasscode/helpers.js");
var _style = _interopRequireDefault(require("./style.css"));
var _image = _interopRequireDefault(require("cccisd-icons/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var PasscodePrompt = function PasscodePrompt(_ref) {
  var fields = _ref.fields;
  var passcodeLabel = fields.passcodeLabel,
    passcodeBackground = fields.passcodeBackground,
    passcodeBackgroundColor = fields.passcodeBackgroundColor,
    passcodeBackgroundUpload = fields.passcodeBackgroundUpload,
    passcodeAssistant = fields.passcodeAssistant;
  var renderAssistant = function renderAssistant() {
    var assistant = passcodeAssistant.value;
    if (!assistant || !_cccisdLaravelFlow.assistants[assistant]) {
      return null;
    }
    var Component = _cccisdLaravelFlow.assistants[assistant].Side;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].assistant
    }, /*#__PURE__*/_react["default"].createElement(Component, null));
  };
  var backgroundImage = passcodeBackground.value;
  var backgroundMinHeight = function backgroundMinHeight(option) {
    if (option === 'brownclassroom') {
      return '40vh';
    }
    if (option === 'city') {
      return '45vh';
    }
    return '33vh';
  };
  var removeBgcaOllie = function removeBgcaOllie() {
    var ollie = _cccisdLaravelFlow.assistantOptions.filter(function (option) {
      return option.value === 'ollieStandard';
    });
    ollie.length === 1 && (ollie[0].label = 'Ollie');
    return _cccisdLaravelFlow.assistantOptions.filter(function (option) {
      return option.value !== 'ollie';
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: '2em',
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: passcodeLabel,
    label: "Text of Passcode Prompt"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "text"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(passcodeLabel)))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: passcodeBackground,
    label: "Passcode Background"
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "form-select"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(passcodeBackground), {
    value: passcodeBackground.value
  }), /*#__PURE__*/_react["default"].createElement("option", {
    value: "solidColor"
  }, "Solid Color"), _cccisdLaravelFlow.backgroundOptions.filter(function (option) {
    return option.value !== '';
  }).map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  }), /*#__PURE__*/_react["default"].createElement("option", {
    value: "uploadedImage"
  }, "Upload Image"))), passcodeBackground.value === 'solidColor' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: passcodeBackgroundColor,
    label: "Pick the color"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.ColorPicker, _extends({
    field: passcodeBackgroundColor
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(passcodeBackgroundColor)))), passcodeBackground.value === 'uploadedImage' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: passcodeBackgroundUpload
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, _extends({
    value: passcodeBackgroundUpload.value
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(passcodeBackgroundUpload), {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-info btn-sm"
    }, /*#__PURE__*/_react["default"].createElement(_image["default"], {
      spaceRight: true
    }), passcodeBackgroundUpload.value ? 'Change Image' : 'Upload Image')
  })))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: passcodeBackgroundUpload
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: passcodeBackgroundUpload.value.name,
    src: passcodeBackgroundUpload.value.thumbnailSmall,
    width: "60px",
    style: {
      borderRadius: '5px',
      marginRight: '0.5em'
    }
  }), /*#__PURE__*/_react["default"].createElement("i", null, passcodeBackgroundUpload.value.name))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: passcodeAssistant,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Passcode Assistant",
      tooltip: "Assistant's position in the preview does not exactly correspond to where it will be on the landing page."
    })
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "form-select"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(passcodeAssistant), {
    value: passcodeAssistant.value
  }), removeBgcaOllie().map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].preview,
    style: {
      backgroundImage: (0, _helpers.showBackground)(backgroundImage, passcodeBackgroundUpload.value),
      backgroundColor: passcodeBackground.value === 'solidColor' ? (0, _helpers.showBackgroundColor)(passcodeBackgroundColor.value) : '',
      border: passcodeBackground.value === 'uploadedImage' ? '0.5px solid #aaaaaa' : '',
      minHeight: backgroundMinHeight(passcodeBackground.value),
      backgroundSize: passcodeBackground.value === 'uploadedImage' && passcodeBackgroundUpload.value ? 'cover' : 'contain'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].previewForm
  }, passcodeLabel.value, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].previewLabel
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].previewSubmitButton
  })), renderAssistant()));
};
var _default = exports["default"] = PasscodePrompt;
PasscodePrompt.propTypes = {
  fields: _propTypes["default"].object
};